import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

const ROUTE_CHUNK_RELOAD_KEY = "magic-builders-route-chunk-reloaded";

window.addEventListener("vite:preloadError", (event) => {
  if (sessionStorage.getItem(ROUTE_CHUNK_RELOAD_KEY) === "1") return;
  event.preventDefault();
  sessionStorage.setItem(ROUTE_CHUNK_RELOAD_KEY, "1");
  window.location.reload();
});

createRoot(document.getElementById("root")!).render(<App />);
